import React from 'react';
import { Box } from '@mui/material';
import TopBar from "../../../../../../../component/TopBar";
import MainBox from "../../../../../container/MainBox";
import PolicyDetails from "../../../../../../../component/PolicyDetails";

const ExpensePolicyDetails = () => {
  return (
    <Box sx={{ width: "100%" }}>
      <TopBar MainHeading={"Expense Policy"} breadcrumbs={[{ label: "Expense Policy", href: "/app/expense-policy/listing" }, { label: "Create" }]} />
      <MainBox sx={{ padding: "2rem 1.25rem" }}>
        <PolicyDetails
          type="ANY"
          listingPageLink="/app/expense-policy/listing"
          addCategoryPageLink="/app/expense-policy/new/add-category"
        />
      </MainBox>
    </Box>
  );
};

export default ExpensePolicyDetails;
